import { gql, TypedDocumentNode } from '@apollo/client';

import {
  MessageReactionReactorsQuery,
  MessageReactionReactorsQueryVariables,
} from '../generated';

export const MESSAGE_REACTION_REACTORS: TypedDocumentNode<
  MessageReactionReactorsQuery,
  MessageReactionReactorsQueryVariables
> = gql`
  query MessageReactionReactors($messageId: String!, $reactionId: String!) {
    messageReactionReactors(messageId: $messageId, reactionId: $reactionId) {
      userId
      displayName
      gravatarHash
    }
  }
`;
